'use client'

import React, { Fragment } from 'react'
import Image from 'next/image'
import styles from './BotCard.module.scss'
import FaqButton from './FaqButton'

const BotTextContainer = ({ isMobile, children }) => {
  if (isMobile) return <div className={styles.botTextContainer}>{children}</div>

  return children
}

const BotCard = ({ taglineLight, taglineBold, botMedia, tag, faqButtons, isMobile, triggerCopilot }) => {
  const { url, alternativeText } = botMedia?.data?.attributes || {}

  const botImgProps = {
    height: isMobile ? 86 : 150,
    width: isMobile ? 86 : 150,
    src: url,
    alt: alternativeText || 'bot-logo',
  }

  return (
    <div className={isMobile ? styles.mobile : styles.desktop}>
      <div className={styles.botCardContainer}>
        <div className={styles.botSection}>
          <div className={styles.botMediaContainer}>
            <Image {...botImgProps} />
          </div>
          <BotTextContainer isMobile={isMobile}>
            {tag?.text && (
              <div className={`${styles.tag} ${styles[`tag--${tag?.colorScheme || 'grey'}`]}`}>{tag.text}</div>
            )}
            {taglineLight && <div className={styles.taglineLight}>{taglineLight}</div>}
            {taglineBold && <div className={styles.taglineBold}>{taglineBold}</div>}
          </BotTextContainer>
        </div>
        <div className={styles.faqSection}>
          {faqButtons.map((btn, index) => (
            <Fragment key={btn.id}>
              <FaqButton btn={btn} handleClick={triggerCopilot} />
              {index < faqButtons.length - 1 && <hr className={styles.separator} />}
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  )
}

export default BotCard
